import { createIcon } from '@chakra-ui/react';

export const Copy = createIcon({
  displayName: 'Copy',
  viewBox: '0 0 16 16',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M11.1673 8.59998V11.4C11.1673 13.7333 10.234 14.6666 7.90065 14.6666H5.10065C2.76732 14.6666 1.83398 13.7333 1.83398 11.4V8.59998C1.83398 6.26665 2.76732 5.33331 5.10065 5.33331H7.90065C10.234 5.33331 11.1673 6.26665 11.1673 8.59998Z" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.1673 4.59998V7.39998C15.1673 9.73331 14.234 10.6666 11.9007 10.6666H11.1673V8.59998C11.1673 6.26665 10.234 5.33331 7.90065 5.33331H5.83398V4.59998C5.83398 2.26665 6.76732 1.33331 9.10065 1.33331H11.9007C14.234 1.33331 15.1673 2.26665 15.1673 4.59998Z" stroke="#6E6789" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </>
  ),
});
